angular
  .module('app')
  .factory('AuthService', AuthService)
  .factory('Reset', Reset)
  .factory('Users', Users)
  .factory('User', User)
  .factory('Summary', Summary)
  .factory('Films', Films)
  .factory('Film', Film)
  .factory('Coupon', Coupon)
  .factory('Config', Config)
  .factory('Countries', Countries)
  .factory('Invoice', Invoice);

function AuthService($http, Session) {
  var authService = {};

  authService.login = function (credentials) {
    return $http.post('api/v2/login', credentials)
      .then(function (res) {
        Session.create(res.data.id, res.data.user);
        return res.data.user;
      });
  };

  authService.register = function (credentials) {
    return $http.post('api/v2/register', credentials)
      .then(function (res) {
        Session.create(res.data.id, res.data.user);
        return res.data.user;
      });
  };

  authService.isAuthenticated = function () {
    return Boolean(Session.userId);
  };

  return authService;
}

function Reset($resource) {
  return $resource('api/v2/reset');
}

function Users($resource) {
  return $resource('api/v2/user/:id', {id: '@id'});
}

function User($resource) {
  return $resource('api/v2/getuser/:id', {id: '@id'});
}

function Summary($resource) {
  return $resource('api/v2/summary/:id', {id: '@id'});
}

function Films($resource) {
  return $resource('api/v2/film/:id/:cat', {id: '@id', cat: '@cat'});
}

function Film($resource) {
  return $resource('api/v2/film', {id: '@id', cat: '@cat'});
}

function Coupon($resource) {
  return $resource('api/v2/coupon/:code', {code: '@code'});
}

function Config($resource) {
  return $resource('api/v2/config');
}

function Countries($resource) {
  return $resource('api/v2/countries');
}

function Invoice($resource) {
  return $resource('api/v2/invoice/:id', {id: '@id'});
}
